/** Case-insensitive union. Keeps the first spelling and sorts for a stable checkbox list. */
export function unionAttributionLabels(...groups: Array<Iterable<string>>): string[] {
  const seen = new Map<string, string>();
  for (const group of groups) {
    for (const value of group) {
      const label = value.trim();
      if (!label) continue;
      const key = label.toLowerCase();
      if (!seen.has(key)) seen.set(key, label);
    }
  }
  return [...seen.values()].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}

/**
 * First non-empty catalog wins, in the same order and spelling as the campaign checkboxes.
 * Pass the campaign contact catalog first so an account-row sample cannot replace it.
 */
export function pickAttributionCatalog(
  ...sources: Array<Iterable<string> | null | undefined>
): string[] {
  for (const source of sources) {
    const labels = unionAttributionLabels(source ?? []);
    if (labels.length) return labels;
  }
  return [];
}

export function attributionLabelsOnContacts(
  rows: Array<{ attributions?: string[] | null }>,
): string[] {
  const labels: string[] = [];
  for (const row of rows) {
    for (const label of row.attributions ?? []) labels.push(label);
  }
  return unionAttributionLabels(labels);
}
